import(/* webpackMode: "eager" */ "/home/kvk_runner/builds/so-ondernemersplein/dop-mono/src/app/global-error.tsx");
